<itl-wizard-page isSinglePage="true" [pageTitleTransPath]="fileName" (cancelClicked)="close()">
  <div save-buttons class="itl-header-actions">
    <itl-button (click)="zoomOut()" [disabled]="zoom <= minZoom" class="itl-header-action itl-header-action--zoom">
      <ion-icon name="remove-outline"></ion-icon>
    </itl-button>
    <itl-button (click)="resetZoom()" class="itl-header-action itl-header-action--zoomLabel">
      <span class="zoom-label">{{ zoom * 100 | number: '1.0-0' }}%</span>
    </itl-button>
    <itl-button (click)="zoomIn()" [disabled]="zoom >= maxZoom" class="itl-header-action itl-header-action--zoom">
      <ion-icon name="add-outline"></ion-icon>
    </itl-button>
    <itl-button *ngIf="showPrintButton" (click)="print()" class="itl-header-action">
      <ion-icon name="alberta-printer-outline"></ion-icon>
      <span>{{ 'components.pdfBox.printButton' | translate }}</span>
    </itl-button>
    <itl-button *ngIf="showShareButton" (click)="share()" class="itl-header-action">
      <ion-icon name="alberta-fab-share"></ion-icon>
      <span>{{ 'components.pdfBox.shareButton' | translate }}</span>
    </itl-button>
    <itl-button *ngIf="showDownloadButton" (click)="download()" class="itl-header-action">
      <ion-icon name="alberta-download-2"></ion-icon>
      <span>{{ 'components.pdfBox.downloadButton' | translate }}</span>
    </itl-button>
  </div>

  <div class="pdfBox">
    <pdf-viewer
      class="pdfViewer"
      [src]="src"
      [render-text]="true"
      [original-size]="false"
      [(page)]="currentPage"
      [zoom]="zoom"
      [zoom-scale]="'page-width'"
    ></pdf-viewer>
  </div>
</itl-wizard-page>
